import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 pt-20 pb-10 border-t border-slate-800" id="contact">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-4 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-6">
              <img
                src="/images/logo.jpg"
                alt="Smile Care Dental Surgery"
                className="h-16 w-auto object-contain rounded-lg bg-white p-1"
              />
              <div>
                <h3 className="text-white font-display font-bold text-xl">Smile Care</h3>
                <p className="text-slate-400 text-sm">Dental Surgery</p>
              </div>
            </div>
            <p className="text-slate-400 mb-8 leading-relaxed pr-6">
              Your premier destination for advanced dental care in Kottawa.
              combining state-of-the-art technology with compassionate service
              to create healthy, beautiful smiles.
            </p>
            <div className="flex justify-center lg:justify-start space-x-4">
              <a
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-primary transition-all duration-300"
                href="https://www.facebook.com/share/16xZhHVTJ3/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-primary transition-all duration-300"
                href="https://www.instagram.com/smilecarevipcenter"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-primary transition-all duration-300"
                href="https://wa.me/94777880894"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* Links & Contact Wrapper */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-4 sm:gap-8">
            {/* Quick Links */}
            <div>
              <h4 className="font-display font-bold text-white text-lg mb-6">Quick Links</h4>
              <ul className="space-y-4">
                <li>
                  <Link className="text-slate-400 hover:text-secondary transition-colors duration-300 flex items-center gap-2" to="/">
                    <i className="fas fa-chevron-right text-xs text-slate-600"></i>
                    Home
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 hover:text-secondary transition-colors duration-300 flex items-center gap-2" to="/about-us">
                    <i className="fas fa-chevron-right text-xs text-slate-600"></i>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 hover:text-secondary transition-colors duration-300 flex items-center gap-2" to="/treatments">
                    <i className="fas fa-chevron-right text-xs text-slate-600"></i>
                    Treatments
                  </Link>
                </li>
                <li>
                  <Link className="text-slate-400 hover:text-secondary transition-colors duration-300 flex items-center gap-2" to="/gallery-page">
                    <i className="fas fa-chevron-right text-xs text-slate-600"></i>
                    Gallery
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-display font-bold text-white text-lg mb-6">Contact Us</h4>
              <ul className="space-y-6">
                <li className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded bg-slate-800 flex items-center justify-center shrink-0 text-primary mt-1">
                    <i className="fas fa-map-marker-alt text-sm"></i>
                  </div>
                  <span className="text-slate-400 text-sm leading-relaxed">
                    103B, Temple Rd, Malapalla, Kottawa
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded bg-slate-800 flex items-center justify-center shrink-0 text-primary">
                    <i className="fas fa-phone-alt text-sm"></i>
                  </div>
                  <span className="text-slate-400 font-medium text-sm">
                    +94 777 880 894
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded bg-slate-800 flex items-center justify-center shrink-0 text-primary">
                    <i className="fas fa-envelope text-sm"></i>
                  </div>
                  <a href="mailto:smilecarevipcenter@gmail.com" className="text-slate-400 text-sm break-all hover:text-white transition-colors">
                    smilecarevipcenter@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Map */}
          <div className="lg:col-span-3">
            <h4 className="font-display font-bold text-white text-lg mb-6">Find Us</h4>
            <div className="w-full h-48 bg-slate-800 rounded-xl overflow-hidden shadow-lg relative group">
              <img
                alt="Map Location"
                className="w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity duration-500"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCWeFXYsNlOzsenoSQLUKFHOBo2uj1v1yi2FbsFZEYHR92jzVzOwuCQQkdMqI2w-jAuyW8jW7HWPz8SwzQ1ZBegu_ywnZuqfQIr2GrqSya3Y-EYEitjxkipZSu0pnOKzZ-rOUCFsjBx320TseLjWz5-UYkgqmkqmPEOT0fF1bJ_JqTfA5Zb1HrZ3uCUT45pFTuA3cfczu2v_iqNdpxbv1jQtrsnIT2LNdNAxwjDgVWyQr32RsfPrqfVTdni0zAMQICfwurQ8WJwDQ1A"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <a
                  href="https://maps.app.goo.gl/jATAtdUR4qQrAhtS6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-slate-900 px-4 py-2 rounded-lg font-bold text-sm shadow hover:scale-105 transition-transform duration-300"
                >
                  Open in Maps
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Smile Care Dental Surgery. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <Link to="#" className="hover:text-secondary transition-colors cursor-default">Privacy Policy</Link>
            <Link to="#" className="hover:text-secondary transition-colors cursor-default">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
